<template>
	<div id="sideNavMobile">
		<div class="logo">
			<img src="@/assets/images/logo.png" />
		</div>
		<div class="mobile__nav">
			<div class="mobile__nav__btn"
			@click="openMenu = !openMenu, toggleMenu()"
			:class="{active: openMenu}" >
			<span></span>
			<span class="mid-line-1"></span>
			<span class="mid-line-2"></span>
			<span></span>
		</div>
	</div>
	<nav id="mainNav" :class="{active: openMenu}">
		<div class="logo center-cont" v-scroll-to="'#hero'">
			<img src="@/assets/images/logo.png" />
		</div>
		<div class="main-menu center-cont" >
			<ul class="menu-inner" >
				<li v-for="(navItem, index) in navItems"
				:key="index"
				v-scroll-to="navItem.link"
				@click="openMenu = !openMenu, toggleMenu()"
				>
				<a :href="navItem.link" class="item">{{ navItem.menuName }}</a>
			</li>
		</ul>

	</div>
	<!-- <div class="exclusive_btn_section">

		<button type="button" class="exclusive_btn" name="button"  @click="ExlusiveContentActive = true" @click.prevent="(e) => $emit('ExlusiveContentShow', 'show')">View Exclusive Content</button>
	</div> -->


</nav>

</div>
</template>

<script>
// import gsap from "gsap";
// import { TweenLite } from "gsap/dist/gsap";
import { ref, reactive, watch, toRefs, computed } from "vue";
import { useStore } from "vuex";
export default {
	name: "SideNavMobile",

	data() {
		return {
			navItems: [
				{
					menuName: "Exclusive Benefits",
					link: "#benefits"
				},
				{
					menuName: "Seat Selection",
					link: "#seat_selection"
				},
				{
					menuName: "Plans & Pricing",
					link: "#account_summary"
				},
				{
					menuName: "Payment Info",
					link: "#paymentInfo"
				},
				// {
				// 	menuName: "IMPORTANT DATES",
				// 	link: "#important_dates"
				// },
				{
					menuName: "FAQ",
					link: "#contact_us"
				},
			],
			openMenu: "",
		};
	},
	mounted() {
		setTimeout(function() {
			window.scrollTo(0, 1);
		}, 500);
	},
	setup() {
		const store = useStore();

		// State
		const state = reactive({

		});

		return { ...toRefs(state) };
	},
	methods: {
		toggleMenu() {
			let menu = document.getElementById("mainNav");
			if (menu.style.height === "0px" || menu.style.height === "") {
				const hamburger = document.querySelector(".mobile__nav__btn");
				hamburger.classList.add("active");
				// TweenLite.to(menu, 0.5, {
				//   height: "95vh"
				// });
			} else {
				// TweenLite.to(menu, 0.5, {
				//   height: 0
				// });
			}
		},

	}
};
</script>

<style lang="scss" scoped>
#sideNavMobile {
	.logo {
		position: relative;;
		border: none;
		img {
			padding: 2px 10px;
			width: 65px;
		}
	}

}
.center-cont {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
}
.quick_link{
	position: relative;
}
.video_btn{
	display: flex;
	// flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 8px 15px;
	// margin: 70px 30px 0px 30px;
	text-decoration:none;
	background: #CC3433;
	border-radius: 55px;
	font-family: 'Verlag Book';
	font-style: normal;
	font-weight: 325;
	font-size: 16px;
	line-height: 19px;
	// @include media-breakpoint-only(md) {
		width:318px;
		margin: 30px auto 0px auto;
	// }

}
#mainNav {
	position: absolute;
	width: 100%;
	top: 0px;
	left: 0;
	padding:0px;
	background-color: #0E3386;
	background-image: none;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top;
	height: 0;
	transition: height 1s ease;
	overflow: scroll;
	&.active {
		height: 100vh;
		// padding: 50px 0px;
	}
	.logo{
		margin:20px 0px;
		img{
			width: auto;
			height: 100px;
		}
	}

	a{
		text-decoration:none;
		font-family: 'Verlag Book';
		font-style: normal;
		font-weight: 325;
		font-size: 16px;
		line-height: 145%;
		/* or 23px */

		text-transform: uppercase;

		/* white */

		color: #FFFFFF !important;
	}
	.exclusive_btn_section{
		width:100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position:relative;
		//margin-left:30px;
		margin-top: 30px;
		.exclusive_btn{
			background: #CC3433;
			border-radius: 55px;
			padding: 8px 15px;
			border:none;
			color:white;
			font-family: 'Verlag Book';
			font-style: normal;
			font-weight: 325;
			font-size: 16px;
			line-height: 19px;
			text-decoration:none;
		}
	}
	.main-menu{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		ul{
			padding-left: 0px;
		}
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 20px;
			&.active{
				background: #CC3433;
				width:230px;
			}
		}

	}

}
.mobile__nav {
	width: 67px;
	height: 40px;
	position: absolute;
	display: block;
	top: 8px;
	right: 0;
	&__btn {
		height: 45px;
		width: 20px;
		// right: 24px;
		margin: 10px 0 0 23px;
		transform: rotate(0deg);
		transition: 0.5s ease-in-out;
		cursor: pointer;
		span {
			display: block;
			position: absolute;
			height: 2px;
			width: 100%;
			background: #fff;
			border-radius: 9px;
			opacity: 1;
			left: 0;
			transform: rotate(0deg);
			transition: 0.25s ease-in-out;
			&:nth-child(1) {
				top: 0px;
			}
			&.mid-line-1 {
				width: 55%;
				top: 7px;
			}
			&.mid-line-2 {
				width: 55%;
				top: 7px;
				right: 0;
				left: inherit;
			}
			&:nth-child(4) {
				top: 14px;
			}
		}
		&.active {
			z-index:100;
			position:relative;
			right:0px;
			span {
				&:nth-child(1) {
					top: 7px;
					transform: rotate(135deg);
				}
				&.mid-line-1 {
					opacity:0;
					// width: 25%;
					// top: 28px;
					// left: 28%;
					// transform: rotate(-135deg);
				}
				&.mid-line-2 {
					opacity:0;
					// width: 25%;
					// top: 28px;
					// right: 32%;
					// transform: rotate(135deg);
				}
				&:nth-child(4) {
					top: 7px;
					transform: rotate(-135deg);
				}
			}
		}
	}
}
</style>
